// extracted by mini-css-extract-plugin
module.exports = {"country":"styles_country__24Exs","header":"styles_header__1b9GN","imageCaption":"styles_imageCaption__3ntGR"};